import { ValidationError } from "@definitions/definitions";
import { ActionStatus, FormState } from "@definitions/index";
import { ZodError, ZodIssue } from "zod";

export const fromErrorToFormState = (error: unknown, index?: any, validateErrorMessage?: string) => {
	if (error instanceof ZodError) {
		let errors: Record<string, ValidationError[] | undefined> = {};
		let messages: string[] = [];
		error.issues?.forEach((issue: ZodIssue) => {
			if (issue.path?.length > 0) {
				errors[`${issue.path.at(-1)}${index ?? ''}`] = [{
					message: [issue.message?.replace("invalid_format_", "")],
					isInvalidFormat: issue.code === 'too_big' || issue.message?.startsWith("invalid_format_"),
				} as ValidationError];
			}
			messages.push(issue.message?.replace("invalid_format_", ""));
		})
		console.error(errors);
		return toFormState(ActionStatus.FAIL, validateErrorMessage ?? (messages.length > 1 ? "Some fields are invalid" : messages[0]), errors);
	} else if (error instanceof Error) {
		return toFormState(ActionStatus.FAIL, error.message);
	} else {
		return toFormState(ActionStatus.FAIL, "An unknown error occurred");
	}
};

export const fromErrorToFormStateJoinPath = (error: unknown) => {
	if (error instanceof ZodError) {
		let errors: Record<string, ValidationError[] | undefined> = {};
		let messages: string[] = [];
		error.issues?.forEach((issue: ZodIssue) => {
			if (issue.path?.length > 0) {
				errors[`${issue.path.join("_")}`] = [{
					message: [issue.message?.replace("invalid_format_", "")],
					isInvalidFormat: issue.code === 'too_big' || issue.message?.startsWith("invalid_format_"),
				} as ValidationError];
			}
			messages.push(issue.message?.replace("invalid_format_", ""));
		})
		console.error(errors);
		return toFormState(ActionStatus.FAIL, messages.length > 1 ? "Some fields are invalid" : messages[0], errors);
	} else if (error instanceof Error) {
		return toFormState(ActionStatus.FAIL, error.message);
	} else {
		return toFormState(ActionStatus.FAIL, "An unknown error occurred");
	}
};

export const toFormState = (
	key: ActionStatus,
	message: string,
	errors?: Record<string, ValidationError[] | undefined>
): FormState => {
	return {
		key,
		message,
		errors: errors ?? {},
		timestamp: Date.now(),
	};
};
